import { PopoverTrigger } from '@spotify-internal/encore-web';
import React, { MouseEventHandler, useCallback } from 'react';
import styled from 'styled-components';

import { useCustomer } from 'utils/user';
import { MastheadLinkOrLinkListArray } from 'lib/sanity/types';
import { NavBarAvatar } from 'components/Masthead/Header/Avatar';
import { useUbiMastheadHeader } from 'utils/ubi/pages/useUbiHeader';
import useDropdown from 'components/Masthead/Header/hooks/useDropdown';
import { NavBarProfileLinksPopoverOverlay } from 'components/Masthead/Header/Popover/ProfileLinksOverlay';

const StyledButton = styled.button`
  background: transparent;
  border: none;
  display: inline-flex;
  min-block-size: auto;
  padding: 0;
`;

type Props = {
  profileLinks: MastheadLinkOrLinkListArray;
};

export const NavBarProfileLinksPopover = ({ profileLinks }: Props) => {
  // needs to be vertical friendly
  const { isFetching, user } = useCustomer();
  const ubi = useUbiMastheadHeader();
  const { handlers, open } = useDropdown('profile-links-popover');

  const toggle = useCallback<MouseEventHandler>(
    e => {
      if (!isFetching) {
        ubi.logAvatarInteraction(!open);
        handlers.handleToggle(e);
      }
    },
    [handlers, isFetching, open, ubi],
  );

  return (
    <PopoverTrigger
      onShow={() => {}}
      onHide={() => {}}
      placement="bottomStart"
      overlay={open && <NavBarProfileLinksPopoverOverlay isLoggedIn={user !== null} profileLinks={profileLinks} />}
    >
      <StyledButton data-testid="navbar-avatar" onClick={toggle}>
        <NavBarAvatar loading={isFetching} src={user?.images?.[0]?.url || ''} />
      </StyledButton>
    </PopoverTrigger>
  );
};
